export default {
  callNextPassword: {
    method: "post",
    url: "manage-attendances/call-next-attendance",
  },

  callAbsentAttendance: {
    method: "post",
    url: "manage-attendances/absent-attendance",
  },

  cancelPassword: {
    method: "put",
    url: "manage-attendances/cancel-attendance",
  },

  proceedAttendance: {
    method: "put",
    url: "manage-attendances/attendance-in-progress",
  },

  concludeAttendance: {
    method: "put",
    url: "manage-attendances/attendance-completed"
  },

  listGuiches: {
    method: "get",
    url: "guiche",
  },

  listCurrentPasswords: {
    method: "get",
    url: "manage-attendances/waiting-attendances"
  }
};
